import { createSlice } from "@reduxjs/toolkit";
import downloadInvoiceApi from "@custom/rtk-apis/billing/invoice/downloadInvoice";

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const downloadInvoiceSlice = createSlice({
  name: "downloadInvoiceSlice",
  initialState,
  reducers: {revertStatus (state:any) { state.status = ""; }},
  extraReducers: (builder) => {
    console.log("----------", builder)
    builder
      .addCase(downloadInvoiceApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(downloadInvoiceApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(downloadInvoiceApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default downloadInvoiceSlice.reducer;
export const { revertStatus } = downloadInvoiceSlice.actions;
